<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Niet aftrekbare kosten
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voorbeelden van kosten die niet aftrekbaar zijn:
                <li class="list">telefoonabonnementen voor telefoonaansluitingen in de woonruimte</li>
                <li class="list">kosten van persoonlijke verzorging</li>
                <li class="list">kosten van muziekinstrumenten, apparatuur en gereedschappen die bij het privévermogen horen of die
                    privé gehuurd zijn
                <li class="list">standsuitgaven, zoals het lidmaatschap van een serviceclub of de Rotary</li>
                <li class="list">kosten van vaartuigen voor representatieve doeleinden</li>
                <li class="list">kosten van een werkruimte en de inrichting ervan in de woning die de ondernemer niet als zakelijk
                    aanmerkt.
                    In een aantal situaties zijn kosten van een werkruimte wel aftrekbaar.
                <li class="list">kleding, met uitzondering van werkkleding. Werkkleding is onder voorwaarden aftrekbaar.</li>

                <div class="space10"></div>
                <b>Verwerken in administratie en aangifte</b><br/>
                Kosten die niet aftrekbaar zijn moet je wel invullen in de administratie én de aangifte. Dan zijn er
                verschillende methoden om de boetes te verwerken:<br/>
                1. Je boekt de niet-aftrekbare kosten als privékosten. Bij het opmaken van de jaarrekening hoef je
                dan geen correctie toe te passen.<br/>
                2. Je boekt de niet-aftrekbare kosten volledig als kosten op de winst-en-verliesrekening. Bij de
                aangifte pas je dan hier een correctie toe voor deze niet-aftrekbare kosten.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Niet aftrekbare boetes
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voorbeelden van boetes die niet aftrekbaar zijn:
                <li class="list">geldboetes die zijn opgelegd door een Nederlandse strafrechter</li>
                <li class="list">geldsommen om strafvervolging te voorkomen</li>
                <li class="list">boetes opgelegd door de Autoriteit Consument & Markt (ACM)</li>
                <li class="list">boetes en verhogingen die zijn opgelegd bij de heffing van belastingen en premies</li>
                <li class="list">parkeerbonnen</li>
                <li class="list">geldboetes die zijn opgelegd door een buitenlandse overheid of overheidsinstelling</li>
                <li class="list">dwangsommen en daarmee vergelijkbare buitenlandse dwangsommen</li>

                <div class="space10"></div>
                <b>Verwerken in administratie en aangifte</b><br/>
                Boetes die niet aftrekbaar zijn moet je wel invullen in de administratie én de aangifte. Dan zijn er
                verschillende methoden om de boetes te verwerken:<br/>
                1. Je boekt de boetes als privékosten. Bij het opmaken van de jaarrekening hoef je dan geen
                correctie toe te passen.<br/>
                2. Je boekt de boetes volledig als kosten op de winst-en-verliesrekening. Bij de aangifte pas je dan
                hier een correctie toe voor deze boetes.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Beperkt aftrekbare kosten
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voorbeelden van kosten die gedeeltelijk niet aftrekbaar zijn:
                <li class="list">verhuiskosten</li>
                <li class="list">kosten van privévervoermiddelen</li>
                <li class="list">een gebruiksvergoeding voor privébezittingen (geen vervoermiddelen) die de ondernemer zakelijk
                    gebruikte
                </li>
                <li class="list">een gebruiksvergoeding voor privé gehuurde zaken (geen vervoermiddelen) die de ondernemer zakelijk
                    gebruikte
                </li>
                <li class="list">beroepspensioenpremies</li>

                <div class="space10"></div>
                <b>Verwerken in administratie en aangifte</b><br/>
                Kosten die niet aftrekbaar zijn moet je toch invullen in de administratie én de aangifte. Dan zijn er
                verschillende methoden om de gedeeltelijk aftrekbare kosten te verwerken in de administratie en
                aangifte:<br/>
                1. je boekt de gedeeltelijk aftrekbare kosten als privékosten. Bij de aangifte hoef je
                geen correctie toe te passen.<br/>
                2. Je boekt de gedeeltelijk aftrekbare kosten volledig als kosten op de resultatenrekening.
                Bij de aangifte pas je dan een correctie toe voor deze gedeeltelijk aftrekbare kosten.<br/>
                3. Is er sprake van een drempelbedrag? Dan kun je alleen de kosten die boven de drempel uitkomen,
                opnemen in de resultatenrekening.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Vrijgestelde winstbestanddelen
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Voor een aantal winstbestanddelen geldt een vrijstelling. Bij de berekening van de belastbare winst
                worden deze vrijstellingen van de winst afgetrokken. Het gaat dan om:
                <li class="list">de bosbouwvrijstelling</li>
                <li class="list">de landbouwvrijstelling</li>
                <li class="list">de vrijstelling voor kwijtscheldingswinst</li>
                <li class="list">overige vrijgestelde winstbestanddelen</li>

                <div class="space10"></div>

                <b>Vrijstelling voor kwijtscheldingswinst</b><br>
                De vrijstelling voor kwijtscheldingswinst is een vrijstelling voor winst die ontstaat als een
                schuldeiser afziet van het innen van een schuld die je bij hem hebt. In dat geval levert dit de
                ondernemer winst op.<br/>
                Deze winst is vrijgesteld onder de volgende voorwaarden:
                <li class="list">de schuld is niet te innen, bijvoorbeeld door een (dreigend) faillissement.</li>
                <li class="list">van de winst die is behaald met de kwijtschelding, is alleen het deel vrijgesteld dat hoger is dan
                    de te verrekenen verliezen uit werk en woning van de jaren tot en met vorig aangiftejaar en het
                    verlies uit werk en woning over het aangiftejaar. Verliezen in jaren die volgen op het jaar van de
                    kwijtschelding, verkleinen het vrijgestelde bedrag niet.
                </li>

                <div class="space10"></div>
                <b>Overige vrijgestelde winstbestanddelen</b><br/>
                Overige vrijgestelde winstbestanddelen zijn:
                <li class="list">pensioenaanspraken volgens een verplichte bedrijfs- of beroepspensioenregeling</li>
                <li class="list">vergoedingen voor bedrijfsbeëindiging</li>
                <li class="list">uitkeringen volgens de Waz (Wet arbeidsongeschiktheid zelfstandigen) en aanspraken op uitkeringen
                    Waz
                </li>
                <li class="list">bepaalde subsidies voor bos en natuur</li>
                <li class="list">voordelen die zijn belast in de loonbelasting door eindheffing</li>
                <li class="list">vergoedingen voor spitsmijdenprojecten (vergoeding die de ondernemer ontvangt uit projecten die zijn
                    gericht op hinderbeperking tijdens grootschalige wegwerkzaamheden)
                </li>

                <div class="space10"></div>
                Heeft de ondernemer een financiële tegemoetkoming ontvangen in verband met corona en moest hij deze
                terugbetalen? Ook dan is sprake van een vrijgesteld winstbestanddeel voor het ontvangen bedrag. Het gaat
                om de 'Regeling subsidie vaste lasten/tegemoetkoming vaste lasten MKB (TVL MKB)'
                en de regeling Tegemoetkoming Ondernemers Getroffen Sectoren (TOGS).
            </div>
        </div>
    </div>

</div>

